import Modal from 'components/Modal';
import Button from 'components/Button';
import React from 'react';
import PropTypes from 'prop-types';
import DateFormats from 'constants/DateFormats';

function CancelModal({ isShowModal, appointment, onClose, onSubmit }) {
  const taxCode = appointment.taxAuthority.codeSOUN || appointment.taxAuthority.taxCode;
  return (
    <Modal showModal={isShowModal} onClose={onClose}>
      <h2>Отмена посещения</h2>
      <div className="page_margin30">
        Вы уверены, что хотите отказаться от посещения{' '}
        {appointment.visitTime.format(DateFormats.long_with_short_time_no_comma)}&nbsp; налогового
        органа №{taxCode}?
      </div>
      <div className="form_buttons form_buttons__right">
        <Button value="Отмена" hasWrapper={false} color="white" size="medium" onClick={onClose} />
        <Button
          value="Подтвердить"
          hasWrapper={false}
          color="blue"
          size="medium"
          onClick={onSubmit}
        />
      </div>
    </Modal>
  );
}

CancelModal.propTypes = {
  isShowModal: PropTypes.bool,
  appointment: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};
export default CancelModal;
